import { Schema } from 'firebase/ai';

export const objectSchema = (properties) => Schema.object({ properties });
export const arraySchema = (items) => Schema.array({ items });
